import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import DocumentsVerificationSC from '../../investor-onboarding-content/documents-verification/documents-verification.styled';

export default styled.div`
  .additional-data-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    &--item {
      margin-bottom: 16px;
      min-height: 100px;
      margin-right: 15px;
      padding: 16px 16px 24px 16px;
      width: calc(100% / 2 - 10px);
      display: flex;
      flex-direction: column;
      border-radius: 12px;
      background-color: #f8f8f9;
      word-break: break-word;

      &.full-width {
        width: calc(100% - 5px);
        margin-right: 0;
      }

      &:nth-child(2n) {
        margin-right: 0px;
      }
    }
  }
  .bottom-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    span {
      padding-bottom: 16px;
    }
    small {
      padding: 16px 0 0 0;
      margin: 0 auto;
    }

    .half-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      button {
        width: calc(50% - 10px);
      }
    }

    .hint-text {
      margin-bottom: 15px;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    .additional-data-wrap {
      justify-content: space-between;
      &--item {
        width: calc(100% / 2 - 10px);
        margin-right: 0px;

        &.full-width {
          width: 100%;
          margin-right: 0;
        }
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    .additional-data-wrap {
      &--item {
        width: 100%;
      }
    }
    .bottom-wrap {
      .half-wrap {
        flex-direction: column;
        button {
          width: 100%;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
    }
  }

  ${DocumentsVerificationSC}:not (:first-of-type) {
    padding-top: 0;
  }
`;
